import { render, staticRenderFns } from "./Allocator.vue?vue&type=template&id=28575a12&"
import script from "./Allocator.vue?vue&type=script&lang=js&"
export * from "./Allocator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports